module.exports = __webpack_public_path__ + "img/svg/steps-background-mobile.f44fb659234c796c9c09faf8a6ce8c52.svg";